import {useNavigate} from "react-router-dom";
import {useContext, useEffect, useState} from "react";
import Searchbar from "./Searchbar";
import {AuthContext} from "../contexts/AuthContext";


const Profileactions = () => {

    const navigate = useNavigate();

    const {
        type, STATES, user, logout
    } = useContext(AuthContext)

    const [profileMenuOpen, setProfileMenuOpen] = useState(false);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (!event.target.closest('.profileimage')) {
                setProfileMenuOpen(false);
            }
        };
        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);

    const PROFILEACTIONS = [
        {
            name: 'Déconnexion',
            action: () => {
                setProfileMenuOpen(false);
                logout();
            }
        }
    ];


    return <div className="profileactions">
        {
            type === STATES[0] && <>
                <Searchbar/>
                <button className="profilebtn">
                    <svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M14.8765 14.79L13.5865 13.5V8.5C13.5865 5.43 11.9465 2.86 9.08648 2.18V1.5C9.08648 0.67 8.41648 0 7.58648 0C6.75648 0 6.08648 0.67 6.08648 1.5V2.18C3.21648 2.86 1.58648 5.42 1.58648 8.5V13.5L0.296477 14.79C-0.333523 15.42 0.106477 16.5 0.996477 16.5H14.1665C15.0665 16.5 15.5065 15.42 14.8765 14.79ZM11.5865 14.5H3.58648V8.5C3.58648 6.02 5.09648 4 7.58648 4C10.0765 4 11.5865 6.02 11.5865 8.5V14.5ZM7.58648 19.5C8.68648 19.5 9.58648 18.6 9.58648 17.5H5.58648C5.58648 18.6 6.47648 19.5 7.58648 19.5Z"
                            fill="#A3AED0"/>
                    </svg>
                </button>
                <button className="profilebtn">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M13.7317 8.78333C13.765 8.53333 13.7817 8.275 13.7817 8C13.7817 7.73333 13.765 7.46667 13.7233 7.21667L15.415 5.9C15.565 5.78333 15.6067 5.55833 15.515 5.39167L13.915 2.625C13.815 2.44167 13.6067 2.38333 13.4233 2.44167L11.4317 3.24167C11.015 2.925 10.5733 2.65833 10.0817 2.45833L9.78167 0.341667C9.74833 0.141667 9.58167 0 9.38167 0H6.18167C5.98167 0 5.82333 0.141667 5.79 0.341667L5.49 2.45833C4.99833 2.65833 4.54833 2.93333 4.14 3.24167L2.14833 2.44167C1.965 2.375 1.75667 2.44167 1.65667 2.625L0.0650003 5.39167C-0.0349997 5.56667 -0.00166647 5.78333 0.165 5.9L1.85667 7.21667C1.815 7.46667 1.78167 7.74167 1.78167 8C1.78167 8.25833 1.79833 8.53333 1.84 8.78333L0.148334 10.1C-0.00166646 10.2167 -0.043333 10.4417 0.0483336 10.6083L1.64833 13.375C1.74833 13.5583 1.95667 13.6167 2.14 13.5583L4.13167 12.7583C4.54833 13.075 4.99 13.3417 5.48167 13.5417L5.78167 15.6583C5.82333 15.8583 5.98167 16 6.18167 16H9.38167C9.58167 16 9.74833 15.8583 9.77333 15.6583L10.0733 13.5417C10.565 13.3417 11.015 13.075 11.4233 12.7583L13.415 13.5583C13.5983 13.625 13.8067 13.5583 13.9067 13.375L15.5067 10.6083C15.6067 10.425 15.565 10.2167 15.4067 10.1L13.7317 8.78333ZM7.78167 11C6.13167 11 4.78167 9.65 4.78167 8C4.78167 6.35 6.13167 5 7.78167 5C9.43167 5 10.7817 6.35 10.7817 8C10.7817 9.65 9.43167 11 7.78167 11Z"
                            fill="#A3AED0"/>
                    </svg>
                </button>
                <button className="profilebtn">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M9 5H11V7H9V5ZM10 15C10.55 15 11 14.55 11 14V10C11 9.45 10.55 9 10 9C9.45 9 9 9.45 9 10V14C9 14.55 9.45 15 10 15ZM10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18Z"
                            fill="#A3AED0"/>
                    </svg>
                </button>
                <button className="profileimage"
                        onClick={() => setProfileMenuOpen(!profileMenuOpen)}
                >
                    <div className={
                        profileMenuOpen ? 'profileimagemenu active' : 'profileimagemenu'
                    }>
                        {
                            PROFILEACTIONS.map((action, index) => (
                                <div key={index} className="profilemenuitem"
                                     onClick={action.action}>
                                    {action.name}
                                </div>
                            ))
                        }
                    </div>
                </button>
            </>
        }
        {
            type === STATES[1] && <button className="profilecookie"
                                          onClick={() => navigate("/login")}>
                Connexion
            </button>
        }
        {
            type === STATES[2] && <button className="profilecookie"
                                          onClick={() => navigate("/dashboard")}>
                Ouvrir en tant que {user?.firstName} {user?.lastName}
            </button>
        }
        {
            type === STATES[4] && <div>
                {/*Bonjour {user?.firstName} {user?.lastName}*/}
                <button className="profilecookie"
                        onClick={() => logout()}>
                    Déconnexion
                </button>
            </div>
        }
    </div>
}

export default Profileactions;